// extracted by mini-css-extract-plugin
export default {"root":"_2knZ06i4oQjVh1D-wotlCm","fullStar":"_3rUZEpjbIqlWtVs1mLf81R","averageScore":"_10h_9QwFVIdvCLPzruKOvX"};